import { gql } from "@apollo/client";

export const LOCKER_TYPE_FOR_LOCKER_USER_TEMPLATE = gql`
	{
		lockerTypes {
			lockerTypeId
			lockerType
		}
	}
`;

export const OPERATOR_MESSAGE_TEMPLATE = gql`
	query (
		$operatorId: ID!
		$lockerTypeId: ID!
		$menuGroup: String!
		$messageGroup: String!
	) {
		operatorMessageTemplates(
			operatorId: $operatorId
			lockerTypeId: $lockerTypeId
			menuGroup: $menuGroup
			messageGroup: $messageGroup
		) {
			operatorMessageTemplateId
			messageViaSms
			messageViaApp
			messageMedia
			operatorMessageType {
				messageTitle
				variableNames
				messageViaSmsDefault
				messageViaAppDefault
				operatorMessageTypeId
			}
		}
	}
`;

export const UPDATE_MESSAGE_TEMPLATE = gql`
	mutation ($operatorMessageTemplateArg: [UpdateMessageTemplateObj]) {
		updateMessageTemplateBulk(
			operatorMessageTemplateArg: $operatorMessageTemplateArg
		) {
			operatorMessageTemplate {
				operatorMessageTemplateId
			}
		}
	}
`;

export const CREATE_MESSAGE_TEMPLATE = gql`
	mutation ($input: CreateMessageTemplateInput!) {
		createMessageTemplate(input: $input) {
			operatorMessageTemplate {
				operatorMessageTemplateId
				messageMedia
				messageViaSms
				messageViaApp
			}
		}
	}
`;

export const BULK_CREATE_MESSAGE_TEMPLATE = gql`
	mutation ($inputs: [BulkCreateMessageTemplateInput]!) {
		bulkCreateMessageTemplate(inputs: $inputs) {
			operatorMessageTemplates {
				operatorMessageTemplateId
				messageMedia
				messageViaSms
				messageViaApp
			}
		}
	}
`;
